import React from 'react';
import { Box, Text } from '@rsos/components/capstone/base';
import InboundAlerts from '../InboundAlerts';
import OutboundAlerts from '../OutboundAlerts';

const Dashboard = () => {
  return (
    <Box>
      <Box>
        <Text size="header" fontWeight="bold" color="primaryText">
          Alerts Routing
        </Text>
      </Box>
      <Box my={20}>
        <Text size="normal" color="primaryText">
          You can notify alert incidents to peer agencies within a 30 miles
          radius. Please note that sharing an incident doesn’t always guarantee
          that the peer agency will view the shared information.
        </Text>
      </Box>
      <OutboundAlerts />
      <InboundAlerts />
    </Box>
  );
};

export default Dashboard;
